import { useMemo } from "react";
import { Calendar, CalendarProps } from "../ui/calendar";
import { enUS, de, es, fr, it, hr, sl, sr } from "date-fns/locale";
import { i18n } from "@lingui/core";

export const LimeMultipleDayCalendar = (
  props: {} & Exclude<CalendarProps, "locale">,
) => {
  const i18nLocale = i18n.locale;

  const locale = useMemo(() => {
    const code = (i18nLocale || "en").toLowerCase();
    switch (code) {
      case "en":
      case "en-us":
        return enUS;
      case "de":
        return de;
      case "es":
        return es;
      case "fr":
        return fr;
      case "it":
        return it;
      case "hr":
        return hr;
      case "sl":
        return sl;
      case "sr":
      case "sr-rs":
        return sr;
      default:
        return enUS;
    }
  }, [i18nLocale]);

  return <Calendar locale={locale} {...props} />;
};
